import { render, staticRenderFns } from "./DeliveryStatisticsTableBlock.vue?vue&type=template&id=22c0a45a&scoped=true"
import script from "./DeliveryStatisticsTableBlock.vue?vue&type=script&lang=js"
export * from "./DeliveryStatisticsTableBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c0a45a",
  null
  
)

export default component.exports